import React from 'react';

import { useSnackbar } from 'hooks/useSnackbar';
import logger from 'utils/logger';

class EditorErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    this.props.onError(error, errorInfo);
  }

  render() {
    return this.props.children;
  }
}

export default function EditorErrorBoundaryWrap(props) {
  const onSnackbar = useSnackbar();
  const handleError = (error) => {
    onSnackbar("Something isn't working. This may be because of a technical error that we're working to fix.", true);
    logger.error(error);
  };

  return <EditorErrorBoundary onError={handleError} {...props} />;
}
